import type { ReactElement } from 'react'

import { MonthlySalesPDF } from './Pdffiles'
import { MonthlySalesTable } from './Table'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Layout } from '@/components/enlayouts/Ir'

import type { AccordionProps } from '@/pages/ir/financial/monthly-sales'
import { MonthlySales } from '@/types/monthlySales'

type Props = {
  monthlySales: MonthlySales
  yearsPdf: Array<AccordionProps>
}
export const MonthlySalesPage = ({ monthlySales, yearsPdf }: Props) => {
  return (
    <Layout>
      <SectionTitle
        enTitleText="Monthly Sales Report"
        subTitleText=""
        color="normal"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <MonthlySalesTable monthlySales={monthlySales} />
      <Spacer h={{ sp: 80, pc: 100 }} />
      <MonthlySalesPDF yearsPdf={yearsPdf} />
    </Layout>
  )
}

MonthlySalesPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Investor Relations', path: '/en/ir' },
    { name: 'Financial Information', path: '/en/ir/financial/' },
    { name: 'Monthly Sales Report', path: '' },
  ]

  return (
    <>
      <Head
        title="Monthly Sales Report"
        description="The monthly sales performance report for our group's sales outlets."
        ogp={{ url: 'en/ir/financial/monthly-sales' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle=""
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
